import { ISODatetime } from '@models/date';
import { loose } from '@models/util';
import z from 'zod';

export type HistoryAction = z.infer<typeof HistoryAction>;
export type HistoryItemChange = z.infer<typeof HistoryItemChange>;
export type HistoryItem = z.infer<typeof HistoryItem>;
export type DeviceHistoryItem = z.infer<typeof DeviceHistoryItem>;

export const HistoryAction = z.enum(['added', 'changed', 'registered', 'unregistered', 'removed']);

export const HistoryItemChange = z.object({
  path: z.string(),
  oldValue: z.unknown(),
  newValue: z.unknown(),
});

export const HistoryItem = z.object({
  action: loose(HistoryAction),
  modifiedBy: z.object({
    name: z.string().nullish(),
    type: z.string().nullish(),
    userId: z.string().nullish(),
    tokenId: z.string().nullish(),
  }),
  modifiedOn: ISODatetime,
  changes: z.array(
    z.object({
      path: z.string(),
      oldValue: z.unknown(),
      newValue: z.unknown(),
    }),
  ),
});

export const DeviceHistoryItem = HistoryItem.extend({
  deviceId: z.string(),
});
